import React from 'react'
import "./Top.css"
import TypeWriterEffect from 'react-typewriter-effect';
import {FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import {Nav , Navbar , Container} from 'react-bootstrap'
import * as Scroll from 'react-scroll';


const Top = () => {
 
 
  



 
  return (
    <>
   
    <div className="body">

    
    <div className="wraper">
    <Navbar expand="lg">
          <Container>
         
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className='navItems'>
              <Nav className="text-center navItems">
                <Nav.Link  href="#home" className="p-3">
                  Home
                </Nav.Link>
                <Nav.Link to = "/about"  className="p-3" onClick={() =>window.location.replace("./#myself")}>
                  About
                </Nav.Link>
                <Nav.Link href="#My Projects" className="p-3"  onClick={() =>window.location.replace("./#projects")}>
                  My Projects
                </Nav.Link>
                <Nav.Link href="#MyCertifications" className="p-3"  onClick={() =>window.location.replace("./#certi")}>
                  My Certifications
                </Nav.Link>
                <Nav.Link href="#Contact Us" className="p-3"  onClick={() =>window.location.replace("./#contact")}>
                  Get in Touch
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>



{/* Main Content Here */}
<div className="content">
    <h1 className='d-block justify-content-center align-items-center Welcome-Head'>Welcome</h1>
  
    <h3>About Me</h3>
  <h2 className='name'>Azeem Zafar</h2>
   <div className="typewriter">

 
    <TypeWriterEffect
        textStyle={{
          fontFamily:'Ariel',
          color: '#e71d36',
          fontWeight: 500,
          fontSize: '2.7rem',
          textAlign:'center',
          
        }}
        startDelay={2000}
        cursorColor="#e71d36"
        multiText={[
          'A Web Developer...',
          'UI/UX Designer...',
          
        ]}
        loop={true}
        nextTextDelay={1000}
        typeSpeed={50}
      />
        </div>

        <div className="icons">
        <a href="https://www.facebook.com/azeem.zafer.1?mibextid=LQQJ4d" className='p-2' style={{color:"blue"}}><FaFacebook /></a>
       <a href="https://instagram.com/azeem_zafar_17?igshid=ZWIzMWE5ZmU3Zg==" className='p-2'  style={{color:"red"}}><FaInstagram/></a>
        <a href="https://www.linkedin.com/in/azeem-zafar-9b46b61b1/" className='p-2' style={{color:"#0072b1"}}><FaLinkedin/></a>
        </div>


</div>


</div>

</div>
    </>
  )
}

export default Top
